import { isLocalParticipantModerator, isParticipantModerator } from "../base/participants/functions";
const getState = (state) => state['features/changeName-moderation'];
export const isEnableBanAllChangeName = (state) => !!getState(state)?.enabled;
export const isLocalParticipantCanChangeName = (state) => {
    if (isLocalParticipantModerator(state)) {
        return true;
    }
    const { canChangeName } = getState(state);
    if (canChangeName !== undefined) {
        return canChangeName;
    }
    return !isEnableBanAllChangeName(state);
};
export const isParticipantApprovedChangeName = (participantId, state) => getState(state)?.whitelist[participantId];
export const isParticipantRejectedChangeName = (participantId, state) => getState(state)?.blacklist[participantId];
export function isBannedChangeName(participant, state) {
    if (participant.local) {
        return !isLocalParticipantCanChangeName(state);
    }
    // Moderators cannot be banned from changing their name.
    if (isParticipantModerator(participant)) {
        return false;
    }
    if (isEnableBanAllChangeName(state)) {
        return !isParticipantApprovedChangeName(participant.id, state);
    }
    return Boolean(isParticipantRejectedChangeName(participant.id, state));
}
